module.exports = __webpack_public_path__ + "static/media/caraccessByWard2.3e55eefd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/caraccessByWard2.png
// module id = 2084
// module chunks = 0